module.exports = __webpack_public_path__ + "feedbackmodule/img/logo_gocart.1b13c881.png";